import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomRoles = lazy(() => import("@scenes/PermissionSettings/components/CustomRoles"));

export const permissionSettingsRolesNRO: NavigationRoutingObject = {
  Component: CustomRoles,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("roles-nro-heading", "Roles"),
  pageNameForTracking: () => "Roles",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/roles/:appGroupId",
};
